import request from "@/utils/request";

export default function adminReplyMessage(params) {
    return request({
        url: `/newsMessage/agencyReplyMessage`,
        method: 'post',
        data:params
    })
}
